import { createSelector } from 'reselect';
// @ts-expect-error - TS2305 - Module '"monet"' has no exported member 'MaybeType'.
import { Maybe, type MaybeType } from 'monet';
import { getNextgenSettingsJSDAutomationUrl } from '@atlassian/jira-project-settings-apps-common/src/urls';
import {
	baseUrlSelector,
	isProjectSimplifiedSelector,
	projectKeySelector,
} from '@atlassian/jira-servicedesk-automation-common/src/state/selectors/app-props';
import type { RuleSetId, SummaryRuleSet } from '../../../model';
import type { State } from '../../types';
import { maybeEntities, maybeResult } from '../base';

const maybeRuleSet = (state: State, ruleSetId: RuleSetId): MaybeType<SummaryRuleSet> =>
	// @ts-expect-error - TS7006 - Parameter 'entities' implicitly has an 'any' type.
	maybeEntities(state).flatMap((entities) => Maybe.fromNull(entities.ruleSets[ruleSetId]));

const simplifiedEditRuleUrl = (baseUrl: string, projectKey: string, ruleSetId: RuleSetId): string =>
	`${getNextgenSettingsJSDAutomationUrl(projectKey)}/ruleset/${ruleSetId}`;

export const maybeRuleSetIds = (state: State): MaybeType<RuleSetId[]> =>
	// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type.
	maybeResult(state).map((result) => result.ruleSets);

export const getRuleName = (state: State, ruleSetId: RuleSetId): string =>
	maybeRuleSet(state, ruleSetId)
		// @ts-expect-error - TS7006 - Parameter 'ruleSet' implicitly has an 'any' type.
		.map((ruleSet) => ruleSet.name)
		.orSome('');

export const maybeRuleDescription = (state: State, ruleSetId: RuleSetId): MaybeType<string> =>
	// @ts-expect-error - TS7006 - Parameter 'ruleSet' implicitly has an 'any' type.
	maybeRuleSet(state, ruleSetId).flatMap((ruleSet) => Maybe.fromNull(ruleSet.description));

export const isRuleEnabled = (state: State, ruleSetId: RuleSetId): boolean =>
	maybeRuleSet(state, ruleSetId)
		// @ts-expect-error - TS7006 - Parameter 'ruleSet' implicitly has an 'any' type.
		.map((ruleSet) => ruleSet.enabled)
		.orSome(true);

export const getEditRuleUrl = (state: State, ruleSetId: RuleSetId): string => {
	const baseUrl = baseUrlSelector(state);
	const projectKey = projectKeySelector(state);
	return simplifiedEditRuleUrl(baseUrl, projectKey, ruleSetId);
};

export const hasRules = (state: State) =>
	maybeRuleSetIds(state)
		// @ts-expect-error - TS7006 - Parameter 'ruleSetIds' implicitly has an 'any' type.
		.map((ruleSetIds) => ruleSetIds.length > 0)
		.orSome(false);

export const getValidationErrorMessages = createSelector(maybeRuleSet, (ruleSetMaybe) =>
	// @ts-expect-error - TS7006 - Parameter 'ruleSet' implicitly has an 'any' type.
	ruleSetMaybe.map((ruleSet) => ruleSet.validation.errors).orSome([]),
);

export const getIsProjectSimplified = isProjectSimplifiedSelector;
